// Lazy load videos when clicked
const lazyVideoComponents = document.querySelectorAll('.lazy-video');

function loadVideoIframe() {
  const videoSrc = this.getAttribute('data-src');
  let videoIframe = '';

  // Check if it's a Vimeo or YouTube URL
  if (videoSrc.indexOf('vimeo.com') !== -1) {
    const parts = videoSrc.split('/');
    let vimeoID;
    let vimeoHash;

    if(parts.length === 5) {
        // Unlisted video with hash
        vimeoID = parts[parts.length - 2];
        vimeoHash = parts[parts.length - 1];
    } else {
        // Public video without hash
        vimeoID = parts[parts.length - 1];
    }
    videoIframe = `<iframe src="https://player.vimeo.com/video/${vimeoID}?${vimeoHash ? 'h='+vimeoHash : null}&autoplay=1&title=0&byline=0&portrait=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Vimeo Video"></iframe>`;
  } else if (videoSrc.indexOf('youtube.com') !== -1 || videoSrc.indexOf('youtu.be') !== -1) {
    const youtubeID = videoSrc.match(/(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|youtube\.com\/user\/\S+\/|user\/\S+\/\S+|playlist\?|list=)([^#\&\?]*).*/)[1];
    videoIframe = `<iframe src="https://www.youtube.com/embed/${youtubeID}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
  }

  // Inject the video iframe
  if (videoIframe) {
    this.innerHTML = videoIframe;
    this.removeEventListener('click', loadVideoIframe);
  }
}

// Attach click event to each lazy video component
lazyVideoComponents.forEach(function (component) {
  component.addEventListener('click', loadVideoIframe);
});